import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "form-text-input" }
const _hoisted_2 = ["for"]
const _hoisted_3 = ["disabled", "required", "name", "type", "autocomplete"]

import { computed } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'FormTextInput',
  props: {
  modelValue: {
    type: String,
    required: true,
  },

  name: {
    type: String,
    default: null,
  },

  label: {
    type: String,
    default: null,
  },

  errorLabel: {
    type: [Array, String],
    default: null,
  },

  type: {
    type: String,
    default: 'text',
  },

  isDisabled: {
    type: Boolean,
    default: false,
  },

  isRequired: {
    type: Boolean,
    default: false,
  },

  autocomplete: {
    type: String,
    default: 'off',
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const props = __props

const value = computed<string>({
  get: (): string => props.modelValue as string,
  set: (val: string): void => emit('update:modelValue', val),
})

const errorLabelList = computed<Array<string>>(() =>
  Array.isArray(props.errorLabel) ? props.errorLabel : [props.errorLabel],
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          for: __props.name
        }, [
          _createTextVNode(_toDisplayString(__props.label), 1),
          _cache[1] || (_cache[1] = _createElementVNode("span", null, ":", -1))
        ], 8, _hoisted_2))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
      class: _normalizeClass({ 'has-error': Boolean(__props.errorLabel) }),
      disabled: __props.isDisabled,
      required: __props.isRequired,
      name: __props.name,
      type: __props.type,
      autocomplete: __props.autocomplete
    }, null, 10, _hoisted_3), [
      [
        _vModelDynamic,
        value.value,
        void 0,
        { trim: true }
      ]
    ]),
    (__props.errorLabel)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(errorLabelList.value, (error, index) => {
          return (_openBlock(), _createElementBlock("small", {
            key: `error-label-${index}`,
            class: "error-label"
          }, _toDisplayString(error), 1))
        }), 128))
      : _createCommentVNode("", true)
  ]))
}
}

})